import React, { Component, useRef, useState } from 'react';

import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import { withRouter } from 'react-router-dom';
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Dehaze, Logout, Bookmarks, SyncAlt, CameraAlt } from '@mui/icons-material';
import common from '~/common';
import { logError } from '~/common/utils';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import topBar_bg from 'images/topBar_bg.webp';
import white_logo from 'images/white_logo.webp';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const MyMeunItem = ({ text = '', icon = null, onClick = () => {} }) => (
  <MenuItem onClick={onClick}>
    <IconButton size="medium">
      {icon}
    </IconButton>
    {text}
  </MenuItem>
);

class App extends Component {
  state={
    openMenu: false,
  }

  componentDidUpdate (preProps) {
    const { SwitchProjectList: preSwitchProjectList } = preProps;
    const { SwitchProjectList, history, setWindValue } = this.props;
    if (typeof (SwitchProjectList) === 'object' && typeof (preSwitchProjectList) === 'undefined') {
      const windId = localStorage.getItem('Wind_ID') || '';
      let delData = windId.length === 0;
      const isMain = history.location.pathname === `${common.rootPath}/Manage/Main`;
      for (const o of SwitchProjectList) {
        if (o.value === windId) {
          delData = false;
          setWindValue(windId);
        }
      }
      if (delData) {
        localStorage.removeItem('Wind_ID');
        if (!isMain)history.push(`${common.rootPath}/Manage/Main`);
        if (SwitchProjectList.length > 0) { this.setState({ openMenu: true }); }
      }
    }
  }

  componentWillUnmount () {
    const { clearKey } = this.props;
    clearKey('WindValue');
    clearKey('SwitchProjectList');
  }

  renderMenu=() => {
    const { SwitchProjectList = [], history, windValue = '', setWindValue } = this.props;
    const { openMenu } = this.state;
    const onClose = () => this.setState({ openMenu: false });
    return (
      <Menu
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        id="basic-menu"
        anchorEl={this.btnRef}
        getContentAnchorEl={null}
        open={openMenu}
        onClose={windValue.length > 0 ? onClose : () => {}}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {SwitchProjectList.map(o => (
          <div key={o.value}>
            <MyMeunItem
              text={o.name}
              onClick={() => {
                setWindValue(o.value);
                localStorage.setItem('Wind_ID', o.value);
                localStorage.setItem('Wind_Name', o.name);
                onClose();
                if (o.value !== windValue) {
                  history.push(`${common.rootPath}/Manage/Main`);
                  const timer = setInterval(() => {
                    history.push(`${common.rootPath}/Manage/Main/data/basic_contract_view`);
                    clearInterval(timer);
                  }, 50);
                }
              }}
            />
          </div>
        ))}
      </Menu>
    );
  }

  handleScreenshot = () => {
    chrome.tabs.captureVisibleTab(null, {format: 'png'}, (dataUrl) => {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'screenshot.png';
      link.click();
    });
  };
  
  handleScreenshot1 = () => {
    chrome.tabs.captureVisibleTab(null, {format: 'png'}, (dataUrl) => {
      // 將截圖保存為圖像
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'screenshot.png';
      link.click();
    });
  };

  handleScreenshot2 = () => {
    //dom-to-image-more 已被移除
    var node = document.body;

    domtoimage
      .toPng(node)
      .then(function (dataUrl) {
        var img = new Image();
        img.src = dataUrl;
        document.body.appendChild(img);
    })
    .catch(function (error) {
      logError(error, 'toPng');
    });
  };

  handleScreenshot3 = () => {
    html2canvas(document.body, {
      scale: 1,
      useCORS: true,
    }).then((canvas) => {
      const dataURL = canvas.toDataURL();
      // 將截圖保存為圖像
      const link = document.createElement('a');
      link.href = dataURL;
      link.download = 'screenshot.png';
      link.click();
    });
  };
  
  handleScreenshot4 = () => {
    html2canvas(document.body).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = imgData;
      link.download = 'screenshot.png';
      link.click();
    });
  };

  handleScreenshot5 = () => {
    window.print();
  };

  // 截圖
  handleScreenshot6 = () => {
    const input = document.getElementById("content_main_inner");
    
    // 保存原始滾動位置
    const originalScrollPos = { x: window.pageXOffset, y: window.pageYOffset };
    
    // 臨時調整目標元素的樣式以捕獲完整內容
    const originalStyle = input.style.cssText;
    input.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: ${input.scrollWidth}px;
      height: ${input.scrollHeight}px;
    `;
  
    html2canvas(input, {
      allowTaint: true,
      useCORS: true,
      width: input.scrollWidth,
      height: input.scrollHeight,
      scrollX: 0,
      scrollY: 0,
      windowWidth: input.scrollWidth,
      windowHeight: input.scrollHeight
    }).then((canvas) => {
      // 恢復原始樣式和滾動位置
      input.style.cssText = originalStyle;
      window.scrollTo(originalScrollPos.x, originalScrollPos.y);
  
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pageWidth;
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      
      let heightLeft = pdfHeight;
      let position = 0;
  
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;
  
      while (heightLeft >= 0) {
        position = heightLeft - pdfHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeight;
      }
  
      pdf.save('screenshot.pdf');
    }).catch((error) => {
      logError(error, 'toPng');
    });
  };

  handleScreenshot7 = () => {
    const input = document.getElementById("view_main");

    html2canvas(input, { scrollY: -window.scrollY, scrollX: -window.scrollX })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pageWidth;
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        
        // const pdf = new jsPDF();
        // const imgProps = pdf.getImageProperties(imgData);
        // const pdfWidth = pdf.internal.pageSize.getWidth();
        // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('screenshot.pdf');
        
      })
      .catch((error) => {
        logError(error, 'toPng');
      });

      window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
  };

  render () {
    const { onClickTreeBtn, onLogout, SwitchProjectList = [], windValue = '', history, atyFunction } = this.props;

    let windName = '';
    if (windValue.length > 0) {
      for (const o of SwitchProjectList) if (o.value === windValue) windName = o.name;
    }

    const canViewGis = !atyFunction || atyFunction?.fe_report_view;

    return (
      <div style={{ height: 80 }}>
        {this.renderMenu()}
        <img style={{ width: '100%', height: 80, objectFit: 'cover', pointerEvents: 'none' }} src={topBar_bg} alt='' />
        <div style={{ position: 'absolute', top: 39.24, left: 0, width: '100%', display: 'flex', alignItems: 'center' }}>
          <div style={{ marginLeft: 28, cursor: 'pointer' }} onClick={onClickTreeBtn}>
            <Dehaze style={{ width: 24.01, height: 24.15, color: 'white' }} />
          </div>
          {/* <img style={{ width: 40.28, height: 28.17, marginLeft: 20.02, pointerEvents: 'none' }} src={white_logo} alt='' /> */}
          <div className='Arial_Black' style={{ marginLeft: 24.01, fontSize: 20, color: '#064B6F', fontWeight: 500 }}>{common.backTitle}</div>
          <div style={{ flex: 1 }} />
            {/* <div style={{ marginRight: 15, marginLeft: 15 }}>
              <Tooltip title='畫面截圖'>
                <IconButton style={{ width: 29, height: 29 }} onClick={() => this.handleScreenshot()}>
                  <CameraAlt style={{ fontSize: 26, color: 'white' }} />
                </IconButton>
              </Tooltip>
            </div> */}
            {windValue.length > 0 && <div style={{ marginRight: 15.51, color: 'white', fontWeight: 500 }}>{windName}</div>}
            <div style={{ marginRight: 15.51 }}>
              <Tooltip title='切換專案'>
                <IconButton style={{ width: 29, height: 29 }} ref={ref => (this.btnRef = ref)} onClick={() => this.setState({ openMenu: true })}>
                  <Bookmarks style={{ fontSize: 26, color: 'white' }} />
                </IconButton>
              </Tooltip>
            </div>
          <div style={{ marginRight: 15.51 }}>
            <Tooltip title='往前台'>
              <IconButton style={{ width: 29, height: 29 }} onClick={canViewGis ? () => history.push(`${common.rootPath}/Gis`) : () => alert('無檢視『前台報表』權限')}>
                <SyncAlt style={{ fontSize: 26, color: 'white' }} />
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ marginRight: 15.51 }}>
            <Tooltip title='登出'>
              <IconButton style={{ width: 26, height: 26, backgroundColor: 'white' }} onClick={onLogout}>
                <Logout style={{ marginLeft: 3, fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  SwitchProjectList: state.data.SwitchProjectList,
  windValue: state.data.WindValue,
  atyFunction: state.data.AtyFunction,
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  setWindValue: id => {
    dispatch({ type: 'post', body: id, label: 'WindValue' });
    Actions_Wind.getWindIdDetail(dispatch, { id });
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
